import { useFirebaseAuth } from 'src/contexts/AuthContext/FirebaseAuthContext';

const useOrganization = () => {
  const user = useFirebaseAuth();

  const organizationId = user?.organization?.id ?? null;

  return {
    organization: { id: organizationId },
  };
};

export default useOrganization;
